import { LeagueTableView } from '../../components';

/**
 * @desc Core Table My View Class
 */
export default class CoreRegenerateLeagueTableView extends LeagueTableView {
	get className() {
		return "my-leagues-table";
	}
	get childViewOptions() {
		return {
			...super.childViewOptions,
			rounds: this.rounds,
			players: this.players,
			user_team: this.options.user_team,
			type_page: 'regenerate'

		}
	}
}